var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBottomDirectionArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 9,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6923 1.94192L7.44229 8.19192C7.38425 8.25004 7.31531 8.29613 7.23944 8.32759C7.16357 8.35904 7.08224 8.37523 7.0001 8.37523C6.91797 8.37523 6.83664 8.35904 6.76077 8.32759C6.68489 8.29613 6.61596 8.25004 6.55792 8.19192L0.307916 1.94192C0.19064 1.82465 0.124756 1.66559 0.124756 1.49974C0.124756 1.33388 0.19064 1.17482 0.307916 1.05755C0.425191 0.940274 0.584251 0.87439 0.750103 0.87439C0.915956 0.87439 1.07502 0.940274 1.19229 1.05755L7.0001 6.86614L12.8079 1.05755C12.866 0.99948 12.9349 0.953418 13.0108 0.921991C13.0867 0.890564 13.168 0.87439 13.2501 0.87439C13.3322 0.87439 13.4135 0.890564 13.4894 0.921991C13.5653 0.953418 13.6342 0.99948 13.6923 1.05755C13.7504 1.11562 13.7964 1.18456 13.8278 1.26043C13.8593 1.3363 13.8755 1.41762 13.8755 1.49974C13.8755 1.58186 13.8593 1.66318 13.8278 1.73905C13.7964 1.81492 13.7504 1.88386 13.6923 1.94192Z",
    fill: "#727272"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomDirectionArrow);
export default __webpack_public_path__ + "static/media/bottom-direction-arrow.9454a33f8a2cf4b1e35e93b23e1a4799.svg";
export { ForwardRef as ReactComponent };